import { Link } from "react-router-dom";
import { Phone, Globe, MapPin, Star } from "lucide-react";
import { VerificationBadge } from "./VerificationBadge";
import { mediaUrl } from "../lib/api";

export const waLink = (number, name) => {
  if (!number) return null;
  let digits = String(number).replace(/\D/g, "");
  if (digits.length === 10) digits = "1" + digits;
  const msg = encodeURIComponent(`Hola, encontré ${name || "tu negocio"} en MiradaLatina y quisiera más información.`);
  return `https://wa.me/${digits}?text=${msg}`;
};

export const BusinessCard = ({ b, onContact }) => {
  const wa = waLink(b.whatsapp || b.phone, b.name);
  return (
    <Link
      to={`/negocio/${b.id}`}
      data-testid={`business-card-${b.id}`}
      className="group relative flex flex-col overflow-hidden rounded-2xl border border-border bg-card no-tap-highlight transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand/10"
    >
      {b.featured && (
        <span className="absolute left-3 top-3 z-10 inline-flex items-center gap-1 rounded-full bg-brand px-2.5 py-1 text-xs font-bold text-white shadow">
          <Star className="h-3 w-3 fill-white" /> Destacado
        </span>
      )}
      <div className="relative h-40 w-full overflow-hidden bg-muted">
        {b.image_url ? (
          <img
            src={mediaUrl(b.image_url)}
            alt={b.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-brand/15 to-brand-gold/10 text-brand">
            <MapPin className="h-8 w-8" />
          </div>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-lg font-bold leading-tight text-brand-ink">{b.name}</h3>
        </div>
        <VerificationBadge status={b.verification_status} />
        <p className="line-clamp-2 text-sm text-muted-foreground">{b.description}</p>
        <div className="mt-1 flex items-center gap-1 text-xs font-medium text-muted-foreground">
          <MapPin className="h-3.5 w-3.5" />
          {b.city}, {b.state}
        </div>
        <div className="mt-2 flex items-center gap-2" onClick={(e) => e.preventDefault()}>
          {b.phone && (
            <a
              href={`tel:${b.phone}`}
              data-testid={`call-btn-${b.id}`}
              onClick={() => onContact?.(b.id, "call")}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-secondary text-brand-ink transition-colors hover:bg-brand hover:text-white"
            >
              <Phone className="h-4 w-4" />
            </a>
          )}
          {wa && (
            <a
              href={wa}
              target="_blank"
              rel="noreferrer"
              data-testid={`whatsapp-btn-${b.id}`}
              onClick={() => onContact?.(b.id, "whatsapp")}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-whatsapp text-white transition-transform hover:scale-110"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 018.413 3.488 11.82 11.82 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.517 5.26l-.999 3.648 3.471-.907z"/></svg>
            </a>
          )}
          {b.website && (
            <a
              href={b.website}
              target="_blank"
              rel="noreferrer"
              data-testid={`website-btn-${b.id}`}
              onClick={() => onContact?.(b.id, "website")}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-secondary text-brand-ink transition-colors hover:bg-brand hover:text-white"
            >
              <Globe className="h-4 w-4" />
            </a>
          )}
        </div>
      </div>
    </Link>
  );
};
